// @givmo/app-charity — the standard page frame for the console's own pages.
//
// The Admin Console pages, the apps statement and the preferences page render inside this: a
// bounded content column with the design-system `PageHeader` at the top — the same frame the
// company console's pages wear, so an admin moving between the two consoles does not re-learn the
// furniture. The class pages (the statement, Payments, Profile, Admins) keep their own frames.

import type { ReactNode } from 'react';
import { PageHeader, testIdProp } from '@givmo/design-system';

export interface PageShellProps {
  title: string;
  /** One honest sentence about what this page is. Optional — omit rather than pad. */
  description?: ReactNode;
  /** Primary action(s) for the page, rendered in the header. */
  actions?: ReactNode;
  /** The page's stable root testid (the e2e/RTL data contract). */
  testId: string;
  children: ReactNode;
}

export function PageShell({ title, description, actions, testId, children }: PageShellProps) {
  return (
    <div
      className="mx-auto flex w-full max-w-[1080px] flex-col gap-24 p-24"
      {...testIdProp(testId)}
    >
      <PageHeader title={title} subtitle={description} actions={actions} />
      {children}
    </div>
  );
}
